import { AIRMEN } from '../config';

export const getAirmenInfo = level => {
  return AIRMEN.find(i => i.id === level) || {};
};

export const getMechaTypeInfo = (level, id) => {
  return getAirmenInfo(level).mechaType?.find(i => i.id === id) || {};
};
